import _ from 'lodash';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewChecked 
} from '@angular/core';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import { SessionService } from '../../services/session.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SpinnerService } from '../../services/spinner.service';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from '../../services/session-storage.service';
import { CommonUiNavConfig } from '../../types/common-ui-nav-config';
import { MessageService } from '../../services/message.service';
import { ModalService } from '../../services/modal.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from '../../services/log.service';
import { Application } from '../../types/application';
import { Location } from '@angular/common';
import { LogoutService } from '../../services/logout.service';
import { ToasterService } from '../../services/toaster.service';
import { AuditReportStatus } from '../../../../node_modules/aws-sdk/clients/acmpca';
import { AuditService } from '../../services/audit.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RouterService } from '../../services/router.service';
import { NetPromoterScoreComponent } from '../npscore/net-promoter-score.component';
import { ForgotPasswordConfirmComponent } from '../forgot-password/forgot-password-confirm.component';
import { NewPasswordRequiredComponent } from '../login/new-password-required/new-password-required.component';
import { PasswordExpiredComponent } from '../login/password-expired/password-expired.component';
import { PrivacyNoticeComponent } from '../privacy/user-privacy-notice.component';

@Component({
  selector: 'app-common-ui',
  templateUrl: './common-ui.component.html',
  styleUrls: ['./common-ui.component.scss'],
  providers: [NgbDropdownConfig]
})
export class CommonUIComponent implements OnInit,OnDestroy,AfterViewChecked  {
  private listenerAdded = false; // Flag to track if listener is added
  private outerThis = this;  // Save the component's `this` context
  private currentAccessToken="";
  private postMessageOnce=false;   //After the first time notify is loaded, onload event should only fire once

  @ViewChild('mainView') iframeElement!: ElementRef<HTMLIFrameElement>;

  private messageListener = function (event: MessageEvent)  {
    // Verify the message origin if needed
    if (event.origin !== window.location.origin) {
      return;
    }

    /*
    if (event.data === 'app:refresh') {
      // Handle the refresh logic for the UIComponent
      console.log('Received refresh message in UIComponent:', event.data);
      

      // Forward the message to the third-party application in the iframe
      const iframe = this.iframeElement.nativeElement; 
      const iframeWindow = iframe.contentWindow;
      const messageOrigin = window.location.origin;
      const messageBody = JSON.stringify({
        type: "UUX-Refresh",
        accessToken: this.sessionStorage.getAccessToken(),
      });
      if (iframeWindow) {
        iframeWindow.postMessage(messageBody, messageOrigin);
      }
    }
      */
  };

  ngAfterViewChecked(): void {
    if (this.loadInIFrame && this.iframeElement && !this.listenerAdded) {
      console.log('Iframe found! Adding event listener.');
      const iframe = this.iframeElement.nativeElement; 
      const organization = this.sessionStorage.getOrganization();

      const messageBody = {
        type: "UUX-Login",
        accessToken: this.sessionStorage.getAccessToken(),
        uuxSessionId: this.sessionStorage.getUUXSessionId(),
        organizationName: organization.OrganizationName,
      };

      this.currentAccessToken=this.sessionStorage.getAccessToken();
      
      iframe.addEventListener('load', () => {
        this.log.trace('Iframe loaded: '+iframe.src);
        try {
          const iframeOrigin = new URL(iframe.src).origin;
          this.log.trace("Iframe Origin: "+iframeOrigin);

        } catch (error) {
          console.error("Error determining iframe origin:", error);
        }
      
        const messageOrigin = environment.notifyUrlOrigin;
        const iframeWindow = iframe.contentWindow;

        
        if (iframeWindow) {
          iframeWindow.postMessage(messageBody, '*');
          this.log.trace('Post UUX-Login Message: '+ JSON.stringify(messageBody));
          this.log.trace('Post Message messageOrigin: '+messageOrigin);
        } else {
          this.log.trace('Iframe contentWindow is not available.');
        }
      }, {once: this.postMessageOnce});
      this.listenerAdded=true;

      iframe.addEventListener('unload', () => {
        this.log.trace('Iframe unloaded: '+iframe.src);
        try {
          const iframeOrigin = new URL(iframe.src).origin;
        } catch (error) {
          console.error("Error determining iframe origin:", error);
        }
        
        const messageOrigin = environment.notifyUrlOrigin;
        const iframeWindow = iframe.contentWindow;
        const logoutMessageBody = {
          type: "UUX-Logout",
        }
        if (iframeWindow) {
          iframeWindow.postMessage(logoutMessageBody, '*');
          this.log.trace('Post Message messageBody: '+logoutMessageBody);
        } else {
          this.log.trace('Iframe contentWindow is not available.');
        }
      });

      const self = this; 
      setInterval(function () {
        const messageOrigin = environment.notifyUrlOrigin;
        const messageBody = {
          type: "UUX-Refresh",
          accessToken: self.sessionStorage.getAccessToken(),
        }
        const iframe = self.iframeElement.nativeElement; 
        const iframeWindow = iframe.contentWindow;

        if (self.listenerAdded && iframeWindow) {
          if (self.currentAccessToken!=self.sessionStorage.getAccessToken()) {
            iframeWindow.postMessage(messageBody, '*');
            self.currentAccessToken=self.sessionStorage.getAccessToken();
            this.log.trace('Post refresh message: '+messageBody);
          }
        }
      }, 60 * 1000); 

    }
  }

  mainViewSrc: string='';
  mainViewForm = {
    url: '',
    body: {
      token: '',
      userPoolId: '',
      region: '',
      org: '',
      uuxSessionId: ''
    }
  };
  navIcons = [];
  navConfig = new CommonUiNavConfig();
  fullUserName: string;
  supportURL: string;
  activeNav = '';
  loadInIFrame: boolean;
  currentAppName: string;

  isDroplinkOpen: boolean;

  onMainViewLoaded: () => void;

  @ViewChild('formSSO')
  formSSO: ElementRef;

  @ViewChild('mainView')
  mainView: ElementRef;

  constructor(
    private session: SessionService,
    private sessionStorage: SessionStorageService,
    private messageService: MessageService,
    private spinner: SpinnerService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private modalService: ModalService,
    private log: LogService,
    private changeRef: ChangeDetectorRef,
    private location: Location,
    private logoutService: LogoutService,
    private toast: ToasterService,
    private routerService: RouterService,
    private auditService: AuditService,
    config: NgbDropdownConfig
  ) {
    config.placement = 'bottom-right';
    config.autoClose = true;
    this.onMainViewLoaded = _.noop;
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageListener);
  }

  private loadApplication(
    url,
    body,
    topLevelRedirect?: boolean,
    pushState?: boolean,
    usePostMessage?: boolean
  ) {
    body = body || {};

    // Push the history state so we can retrieve it later.
    // In some cases we don't want to push the state, such in the popstate event.
    if (pushState) {
      window.history.pushState(
        {
          application: this.sessionStorage.getApplication()
        },
        window.document.title
      );
    }
    if (topLevelRedirect) {
      // If going to Access, set a return-to state for handling
      // history nav from Access back to UUX.
      this.sessionStorage.setHistoryState();
      this.doSSO(
        url,
        body,
        usePostMessage,
        (response: any) => {
          if (window.top.location.pathname !== response.body.url) {
            window.top.location.pathname = response.body.url;
          }
        },
        _.noop
      );
    } else {
      if (url && this.loadInIFrame) {
        this.doSSO(
          url,
          body,
          usePostMessage,
          response => {
            this.mainViewSrc = _.get(response, 'body.url');
            if (_.get(response, 'body.url','').toLowerCase().includes("notify")) {
              this.postMessageOnce=true;
            }
          },
          err => {
            this.mainViewSrc = _.get(err, 'body.url');
            return true;
          }
        );
      }

      // window popstate can occur outside the Angular zone, so run
      // change detection to ensure the iframe is rendered.
      this.changeRef.detectChanges();
    }
  }

  logout() {

    const currentApp = this.sessionStorage.getApplication();
    this.log.trace('current application', currentApp);
    //If moving away from Notify, post a logoff message
    if (currentApp.name=='Notify') {
      const iframe = this.iframeElement.nativeElement; 
        if (iframe) {
          const iframeWindow = iframe.contentWindow;
          const messageBody = {
            type: "UUX-Logout",
          }
          
        if (iframeWindow) {
          iframeWindow.postMessage(messageBody, '*');
          this.log.trace('postMessage', JSON.stringify(messageBody));
        }
      }  
    }

    this.auditService.auditEvent(
      this.session.getUser().username,
      'UserLogout',
      'User clicked Logout in the header',
      {}
    );
    this.routerService.gotoLogout();
  }

  setLoadInIFrameFlag(app: Application) {
    const loadInIFrame = app.name !== 'Audit Report' && app.name !== 'Home' && app.name !== 'Admin' && app.name !== 'Overlays' && app.name !== 'Inbound Patient';

    const updateUi = () => {
      this.loadInIFrame = loadInIFrame;
      this.currentAppName = app.name;
      this.spinner.hideSpinner();
    };
    
    //reset listenerAdded flag
    this.listenerAdded=false;

    // Set flag asynchronously if SSO is required
    if (app.url && !loadInIFrame) {
      this.spinner.showSpinner();
      this.doSSO(app.url, app.body, app.usePostMessage, updateUi, err => {
        // user is not authorized for Admin
        if (app.name === 'Admin') {
          this.toast.showAlert(
            'User is not authorized for User Administration'
          );
        }
        else if (app.name === 'Overlays') {
          this.toast.showAlert(
            'User is not authorized for Overlay Admin'
          );
        }
        else if (app.name === 'Audit Report') {
          this.spinner.hideSpinner();
          this.toast.showAlert(
            'User is not authorized for audit report'
          );
        }
        else if (app.name === 'Inbound Patient') {
          this.spinner.hideSpinner();
          this.toast.showAlert(
            'User is not authorized for inbound patient alert'
          ); 
        }
      });
    } else {
      updateUi();
    }
  }

  ngOnInit() {

    window.addEventListener('message', this.messageListener);

    // Handle popstate events to reload the active app at that time
    // This will not be fired when returning from Access to UUX,
    // but only when clicking Back from within UUX
    this.location.subscribe((event: PopStateEvent) => {
      const application = _.get(event, 'state.application');
      if (application) {
        this.goTo(application, false, application.url);
      }
    });

    let app = this.sessionStorage.getApplication();

    this.fullUserName = this.session.getUser().fullName;
    this.setLoadInIFrameFlag(app);
    this.supportURL= environment.supportLink;
    if (app) {
      // If at the top-level app, Access will always be the active app.
      if (window !== window.parent) {
        const access = environment.applications.access;
        const appUrl = access.getUrl(this.session, this.sessionStorage);
        app = new Application(appUrl.url, appUrl.body, access.name, true);
        this.sessionStorage.setApplication(app);
      }

      // If in UUX and the current state is a top-level page like Access,
      // and not at the end of the history, go back another history item.
      // Otherwise Access will just be loaded again.
      if (
        app.topLevelRedirect &&
        window === window.parent &&
        !this.sessionStorage.isAtHistoryEnd()
      ) {
        window.history.go(-1);
      }
      // Otherwise if the current app is not Access or we are not in an iframe,
      // this is a refresh so load the application
      else if (!app.topLevelRedirect || window === window.parent) {
        this.loadApplication(
          app.url,
          app.body,
          app.topLevelRedirect,
          true,
          app.usePostMessage
        );
      }
      this.activeNav = app.name;
    }

    this.route.data.subscribe(data => {
      this.navConfig = _.get(data, 'navConfig', new CommonUiNavConfig());
    });

    const apps = environment.applications,
      groups = this.session.getUser().securityGroups;

    for (var val of groups) {
      this.log.trace('Group Name->', val);
    }
    this.navIcons = _.compact([
      apps.home,
      showAppIfAuthorized(apps.access),
      showAppIfAuthorized(apps.notify),
      // showAppIfAuthorized(apps.cmc),
      showAuditReportsIfAuthorized(apps.report),
      showAdminIfAuthorized(),
      showAppIfAuthorized(apps.overlay),
      showAppIfAuthorized(apps.inboundPatient, true)
    ]);

    function showAdminIfAuthorized() {
      const found = _.find(groups, group => {
        return (
          group === 'app-access-mxadmin' ||
          group === 'app-access-participantadmin' ||
          group === 'app-notify-participantadmin'
        );
      });
      return found ? apps.admin : undefined;
    }

    function showAuditReportsIfAuthorized(application) {
      const found = _.find(groups, group => {
        return (
          group === 'app-report-user' 
        );
      });
      return found ? application : undefined;
    }

    function showAppIfAuthorized(application, replaceSpaceWithDash: boolean = false) {
      let appName = _.toLower(
        replaceSpaceWithDash ?
          _.replace(application.name, /\s/gi, '-') :
          application.name
        ),
        ignoredRoles = _.get(application, 'ignoredRoles', []);

       /*  //For smoke testing, Notify app is only allowed when the user has app-stella-test role
        if (appName=="notify") {
          const filteredGroups = _.filter(groups, group => _.startsWith(group, 'app-stella-test'));
          console.log('Filtered Groups:', filteredGroups);
          if (!_.isEmpty(filteredGroups)) {
            console.log('Returning application',application);
            return application;
          } else {
            console.log("Returning undefined.");
            return undefined;
          }
        } 

        //For stage testing only, CMC app uses the same roles of Notify
        if (appName=="cmc") {
          appName="notify"
        }
 */
      return !_.isEmpty(
        _.filter(
          groups,
          group =>
            _.startsWith(group, `app-${appName}`) &&
            !_.includes(ignoredRoles, group)
        )
      )
        ? application
        : undefined;
    }
  }

  goTo(application, pushState?: boolean, url?: string) {
    this.log.trace('loading application', application);
    const currentApp = this.sessionStorage.getApplication();
    this.log.trace('current application', currentApp);

    //If moving away from Notify, post a logoff message
    if (currentApp.name=='Notify' && currentApp.name!=application.name) {
      const iframe = this.iframeElement.nativeElement; 
      if (iframe) {
        const iframeWindow = iframe.contentWindow;
        const messageBody = {
          type: "UUX-Logout",
        }
        
        if (iframeWindow) {
          iframeWindow.postMessage(messageBody, '*');
          this.log.trace('postMessage', JSON.stringify(messageBody));
        }
      }  
    }


    // Only reload an app if that app is configured to permit it
    if (!application.allowReload && currentApp.name === application.name) {
      return;
    }
    this.log.trace('current app name->', currentApp.name+' ==='+ application.name);
    // The url is already specified for a serialized state in popstate
    // and functions won't be serialized/deserialized
    let appConfig = {
      url,
      body: _.get(application, 'body'),
      usePostMessage: false
    };
    if (!appConfig.url) {
      appConfig = application.getUrl
        ? application.getUrl(this.session, this.sessionStorage)
        : { url: '' };
    }
    this.log.trace('Storage setApplication->', appConfig.url+'Body->'+ appConfig.body);
    this.sessionStorage.setApplication(
      new Application(
        appConfig.url,
        appConfig.body,
        application.name,
        application.topLevelRedirect,
        appConfig.usePostMessage
      )
    );

    this.activeNav = application.name;

    application.url = appConfig.url;
    application.body = appConfig.body;
    application.usePostMessage = appConfig.usePostMessage;
    this.setLoadInIFrameFlag(application);

    if (window !== window.parent) {
      this.messageService.postRedirectMessage();
    } else {
      this.log.trace('Before loadApplication->'+application.noTimestamp );
      this.loadApplication(
        application.noTimestamp
          ? appConfig.url
          : [appConfig.url, `&ts=${moment().valueOf()}`].join(''),
        appConfig.body,
        application.topLevelRedirect,
        pushState,
        application.usePostMessage
      );
    }

    this.auditService.auditEvent(
      this.session.getUser().username,
      'SSO' + application.name,
      'User selected ' + application.name + ' from the navigation',
      {
        application
      }
    );
  }

  openChangePassword() {
    this.isDroplinkOpen = true;
    this.modalService.open(ChangePasswordComponent);
  }
  openPrivacyNotice(longContent){
    this.isDroplinkOpen = true;
    this.modalService.open(PrivacyNoticeComponent);
    
    this.auditService.auditEvent(
      this.session.getUser().username,
      'UUX Privacy Notice' ,
      'User selected Accept from privacy notice',
      'UUX: UUX'
     );
  }
  openNPSUserExperience(){
    this.isDroplinkOpen = true;
    this.modalService.open(NetPromoterScoreComponent);
  }
  openForgotPassword(){
    this.modalService.open(ForgotPasswordConfirmComponent);
  }
  openPasswordRequired(){
    this.modalService.open(NewPasswordRequiredComponent);
  }
  openPasswordExpired(){
    this.modalService.open(PasswordExpiredComponent);
  }
  openMyAccount() {
    this.isDroplinkOpen = true;
    const appUrl = environment.applications.myAccount.getUrl(
      this.session,
      this.sessionStorage
    );

    this.spinner.showSpinner();

    this.auditService.auditEvent(
      this.session.getUser().username,
      'SSOMyAccount',
      'User opened My Account from the header',
      {
        organization: this.sessionStorage.getOrganization()
      }
    );

    this.doSSO(
      appUrl.url,
      appUrl.body,
      false,
      result => {
        this.spinner.hideSpinner();
        const myAccount = (this.logoutService.myAccountWindow = window.open(
          `/vie/csp/healthshare/hsviewer/MX.HS.UI.Registry.User.IndividualUUX.cls?$ZEN_POPUP=1`,
          '_blank',
          'scrollbars=no,resizable=yes,top=100,left=100,width=1210,height=630'
        ));
        window.addEventListener('unload', () => {
          myAccount.close();
        });
      },
      () => {
        this.spinner.hideSpinner();
        // TODO - show message
      }
    );
  }

  doSSO(url, body, usePostMessage, onSuccess, onError) {
    if (usePostMessage) {
      this.loadInIFrame = true;
      this.mainViewSrc = '';
      setTimeout(() => {
        this.mainViewSrc = url;
        const message = {
          type: 'uux-login',
          payload: body
        };
        this.onMainViewLoaded = () =>
          this.messageService.postMessage(
            JSON.stringify(message),
            'mainView',
            '*'
          );
      });
    } else if (_.includes(url, 'notify')) {
      this.loadInIFrame = true;
      this.mainViewForm.url = url;
      this.mainViewForm.body = body;
      const formEl = this.formSSO.nativeElement;
      // Run after setTimeout to ensure the iframe is rendered for the form target
      setTimeout(() => formEl.submit());
    } else {
      return this.http
        .post(url, body, {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*'
          }),
          observe: 'response'
        })
        .subscribe(onSuccess, onError);
    }
  }

  accountDroplinkOpened(isOpen) {
    setTimeout(() => {
      // If toggled by clicking an option, just toggle it back for next time
      if (this.isDroplinkOpen) {
        this.isDroplinkOpen = false;
      }
      // Otherwise toggle modal message based on the event
      else {
        if (isOpen) {
          this.messageService.postModalOpenMessage();
        } else {
          this.messageService.postModalCloseMessage();
        }
      }
    });
  }

  getLogoSrc() {
    return environment.assets.mxLogo;
  }

  newsItemSelected(url) {
    this.mainViewSrc = url;
    this.loadInIFrame = false;
  }

  openWebToCase() {
    const user = this.session.getUser();
    window.localStorage.setItem('webToCase_name', user.fullName);
    window.localStorage.setItem('webToCase_email', user.email);
  }
}